import script from "./IngredientSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IngredientSelectionModal.vue?vue&type=script&setup=true&lang=js"

import "./IngredientSelectionModal.vue?vue&type=style&index=0&id=5c16d7dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c16d7dc"]])

export default __exports__